<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.texts.' + listitemId + '.data.title'
            "
            :data-default="{
                type: 'raw',
                value: 'Schreiben Sie einen Titel, der Ihr Textelement am besten beschreibt'
            }"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.texts.' + listitemId + '.data.subtitle'
            "
            :data-default="{
                type: 'raw',
                value: 'Schreiben Sie einen Untertitel, der die Überschrift ergänzt'
            }"
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-filepicker
            label="Bild"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.texts.' + listitemId + '.data.image'
            "
            accept=".jpg,.png,.gif"
            :show-focus="false"
            :show-transparency="false"
            :show-scaling-mode="false"
        ></app-filepicker>

        <app-wysiwyg
            label="Text"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.texts.' + listitemId + '.data.text'
            "
            :data-default="{
                type: 'raw',
                value: 'Fassen Sie zusammen, worum es in dem Textelement geht.'
            }"
        ></app-wysiwyg>

        <app-link
            label="Button 1"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.texts.' + listitemId + '.data.link'
            "
        ></app-link>

        <app-link
            label="Button 2"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.texts.' + listitemId + '.data.link2'
            "
        ></app-link>

        <app-link
            label="Button 3"
            :data-source="
                'tecpage.user.modules.' + moduleId + '.data.texts.' + listitemId + '.data.link3'
            "
        ></app-link>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';
import Link from '@/components/assorted/Link.vue';
import { EventBus } from '@/helpers/event-bus';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'hasPackageBasic'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R089'),
            help: this.$helpers.uiText('R085'),
            removeText: this.$helpers.uiText('R091'),
            showGlobal: false
        });
        EventBus.$emit('slider-goto', {
            id: this.listitemId
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-filepicker': Filepicker,
        'app-wysiwyg': Wysiwyg,
        'app-link': Link
    }
};
</script>
